import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';
import { InvoiceModel, InvoiceStatus } from '../invoice-model';
import { InvoicesDataSource } from '../invoices-datasource';

@Component({
  selector: 'app-payments-table',
  templateUrl: './payments-table.component.html',
  styleUrls: ['./payments-table.component.scss'],
  standalone: false
})
export class PaymentsTableComponent {
  @Input() dataSource: InvoicesDataSource;
  @Input() searchText: string;
  @Input() filterItems: ItemPickerModel[];
  @Input() selectedFilterValue: ItemPickerModel;
  @Input() invoiceStatus: typeof InvoiceStatus;
  @Input() getInvoiceStatusIcon: (invoiceModel: InvoiceModel) => string;
  @Input() showSearch: boolean = false;
  @Input() showFilter: boolean = false;
  @Input() isPortal: boolean = false;
  @Output() search = new EventEmitter<string>();
  @Output() itemPickerSelected = new EventEmitter<ItemPickerModel>();
  @Output() openInvoicePayment = new EventEmitter<InvoiceModel>();
  @Output() addCheckReceived = new EventEmitter<InvoiceModel>();
  @Output() copyInvoiceLink = new EventEmitter<void>();

  displayedColumns: Array<string> = [
    'created',
    'invoiceStatus',
    'amount',
    'orderNumber',
    'completionDate',
    'paymentType',
    'actionButtons'
  ];
}
